import { Component, OnInit } from '@angular/core';
import {DeviceType} from "../../model/device-type.model";
import {AttributeDataType, DeviceAttribute} from "../../model/device-attribute.model";
import {DeviceService} from "../../device/device.service";
import {ActivatedRoute, Params, Router} from "@angular/router";
import {MatDialog} from "@angular/material/dialog";
import {UtilService} from "../../shared/util.service";
import {DeviceAttributeDialogComponent} from "../../device-type/device-attribute-dialog/device-attribute-dialog.component";

@Component({
    selector: 'app-device-attribute-edit',
    templateUrl: './device-attribute-edit.component.html',
    standalone: false
})
export class DeviceAttributeEditComponent implements OnInit {

  item: DeviceAttribute;
  types: any[] = [];

  constructor(
    private service: DeviceService,
    private router: Router,
    private route: ActivatedRoute,
    private dialog: MatDialog,
  ) { }

  ngOnInit(): void {
    this.initPage();
  }

  initPage() {
    this.route.params.subscribe((params:Params) => {
      let id = params['id'] ? params['id'] : null;
      if (!id) {
        return this.router.navigate(['/data/device-attribute']);
      } else {
        if (id === 'new') {
          this.item = new DeviceAttribute();
        } else {
          this.fetchItem(id);
        }
      }
    });

    Object.entries(AttributeDataType).map(([key, value]:[any,any]) => {
      this.types.push({
        id: value,
        name: key
      })
    })
  }

  fetchItem(id) {
    this.service.getAttribute(id).subscribe((resp:any) => {
      if (resp && resp.id) {
        this.item = new DeviceAttribute(resp);
      }
    })
  }

  saveItem() {
    this.service.saveAttribute(this.item).subscribe((resp:any) => {
      if (resp.error) {
        return this.service.notiService.open(resp.error);
      }
      this.service.notiService.open('Saved');
      if (!this.item.id) {
        this.item = new DeviceAttribute(resp);
        this.router.navigate(['/data/device-attribute', resp.id]);
      }
    })
  }

  deleteAttribute() {
    this.service.deleteAttribute(this.item.id).subscribe((resp:any) => {
      if (resp.success) {
        this.service.notiService.open("Deleted");
        return this.router.navigate(['/data/device-attribute']);
      } else {
        return this.service.notiService.open("Can not delete this.");
      }
    }, (error:any) => {
      console.log(error);
      return this.service.notiService.open("Can not delete this.");
    })
  }

  onDeleteAttributeClick() {
    this.service.confirmAction().subscribe((isConfirm: boolean) => {
      if (isConfirm) {
        this.deleteAttribute()
      }
    })
  }
}
